import React from "react";
import "./UploadFiles.css";

const UploadFiles = () => {
  return (
    <div className="xena-upload-docs">
      <h1 className="xena-upload-title">
        Uploading Documents (PDF, DOC, DOCX, TXT)
      </h1>

      <p className="xena-upload-intro">
        Learn how to upload documents as training data for your XenaChat
        assistant. Adding structured files allows your bot to reference and
        respond using your uploaded content.
      </p>

      <h2 className="xena-upload-section">Step 1 – Open Your Bot</h2>
      <p>
        From the <strong>Dashboard</strong>, go to <strong>Your Bots </strong> 
        and select the bot you want to train.
      </p>

      <h2 className="xena-upload-section">Step 2 – Access Training Sources</h2>
      <p>
        In the left sidebar, click on <strong>Training</strong>, then choose 
        <strong> Sources</strong>.
      </p>

      <h2 className="xena-upload-section">Step 3 – Upload Files</h2>
      <p>
        Click on the <strong>Files</strong> tab. Then <strong>Upload Files </strong> via drag and drop into the upload area.
      </p>

      <ul className="xena-upload-list">
        <li>Supported formats: PDF, DOC, DOCX, TXT</li>
        <li>Upload using drag and drop</li>
        <li>Wait while the system processes your file</li>
      </ul>

      <h2 className="xena-upload-section">Uploading Spreadsheets</h2>
      <p>
        If you want to upload spreadsheet files, select the 
        <strong> Spreadsheet</strong> tab instead of Files.
      </p>

      <ul className="xena-upload-list">
        <li>Click on Spreadsheet</li>
        <li>Upload your spreadsheet file</li>
        <li>Allow processing to complete</li>
      </ul>

      <h2 className="xena-upload-section">After Upload</h2>
      <p>
        Once uploaded, XenaChat automatically processes and indexes your
        documents. After processing is complete, your assistant can use the
        content to deliver accurate and context-aware responses.
      </p>
    </div>
  );
};

export default UploadFiles;
